
import Vue from "vue";
import { Company } from "@/models/company";
import { Invoice } from "@/models/invoice";
import { SubscriptionSerivce } from "@/services/subscription-service";
import AppCompanyPlan from "./CompanyPlan.vue";
import AppCompanyEditWrapper from "./CompanyEditWrapper.vue";

export default Vue.extend({
	data(){
		return {
			invoices: [] as Invoice[],
			selectedInvoice: null as Invoice | null
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	methods: {
		showPlan(invoice:Invoice){
			this.selectedInvoice = invoice;
		}
	},
	async created(){
		this.invoices = await SubscriptionSerivce.getInvoices(this.company.id);
	},
	components: {
		AppCompanyPlan,
		AppCompanyEditWrapper
	}
});
